import { Ticket } from '../types/ticket'

// RBAC user names carry a role suffix, e.g. "Alessio (Admin)" → "Alessio"
export function getPersonName(userName: string): string {
  return userName.split(' (')[0].trim()
}

export function isTicketCreator(ticket: Ticket, person: string): boolean {
  return ticket.createdBy === person
}

export function isTicketRecipient(ticket: Ticket, person: string): boolean {
  return ticket.recipient === person
}

// Only the issuer and the current recipient may modify a ticket
export function canEditTicket(ticket: Ticket, person: string): boolean {
  return isTicketCreator(ticket, person) || isTicketRecipient(ticket, person)
}

// The recipient (when not also the issuer) cannot change description,
// deadline, or the initial Azienda / Interno choice
export function canEditIssuerFields(ticket: Ticket, person: string): boolean {
  return isTicketCreator(ticket, person)
}
